/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/ban-ts-comment */
import React, { useState } from "react";
import {
  Button,
  Menu,
  MenuItem,
  Popper,
  Paper,
  MenuList,
  Grow,
  ClickAwayListener,
  ListItemText,
  Tooltip,
  tooltipClasses,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import mergeTagsValue from "../../common/template-merge-tags.json";
import { HugeiconsIcon } from "@hugeicons/react";
//@ts-ignore
import { ArrowDown01Icon, ArrowRight01Icon } from "@hugeicons-pro/core-stroke-rounded";
import type { TooltipProps } from "@mui/material/Tooltip";

const BootstrapTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} placement="bottom" arrow={false} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.black,
  },
  [`& .${tooltipClasses.arrow}`]: {
    display: "none",
  },
}));

interface MergeTagsDropdownProps {
  insertAtCursor: (text: string) => void;
  viewMode: string;
}

const MergeTagsDropdown: React.FC<MergeTagsDropdownProps> = ({ insertAtCursor, viewMode }) => {
  const [mainAnchorEl, setMainAnchorEl] = useState<null | HTMLElement>(null);
  const [submenuAnchorEl, setSubmenuAnchorEl] = useState<null | HTMLElement>(null);
  const [hoveredMenu, setHoveredMenu] = useState<any>(null);

  const handleMainClick = (event: React.MouseEvent<HTMLButtonElement>): void => {
    setMainAnchorEl(event.currentTarget);
  };

  const handleMainClose = (): void => {
    setMainAnchorEl(null);
    setHoveredMenu(null);
    setSubmenuAnchorEl(null);
  };

  const handleSubmenuClose = (): void => {
    setHoveredMenu(null);
    setSubmenuAnchorEl(null);
  };

  const isMainOpen = Boolean(mainAnchorEl);

  const menuPaperStyles = {
    boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)",
    backgroundColor: "#ffffff",
  };

  return (
    <>
      <Button
        onClick={handleMainClick}
        endIcon={<HugeiconsIcon icon={ArrowDown01Icon} size={16} color="#3a3a3a" strokeWidth={0.2} />}
        sx={{
          height: "36px",
          textTransform: "none",
          fontFamily: "Manrope, sans-serif",
          color: "#3a3a3a",
          backgroundColor: "#ffffff",
          border: "1px solid #e0e0e0",
          borderRadius: "20px",
          paddingLeft: "16px",
          paddingRight: "12px",
          "&:hover": {
            backgroundColor: "#f9f9f9",
          },
          boxShadow: "none",
        }}
      >
        Merge Tags
      </Button>

      <Menu
        anchorEl={mainAnchorEl}
        open={isMainOpen}
        onClose={handleMainClose}
        slotProps={{ paper: { style: { minWidth: 200, ...menuPaperStyles } }}}
        MenuListProps={{
          onMouseLeave: () => {
            setTimeout(() => {
              if (!submenuAnchorEl) handleMainClose();
            }, 200);
          },
          sx: { padding: "6px 0" },
        }}
      >
        {mergeTagsValue.map((item: any) => {
          const isDisabled = viewMode === "preview" && item.previewDisabled;

          const content = (
            <MenuItem
              key={item.title}
              disabled={isDisabled}
              onClick={() => {
                if (!isDisabled) {
                  insertAtCursor(`{{${item.value}}}`);
                  handleMainClose();
                }
              }}
              onMouseEnter={() => {
                setHoveredMenu(null);
                setSubmenuAnchorEl(null);
              }}
              sx={{
                height: "36px",
                padding: "0 16px",
                opacity: isDisabled ? 0.5 : 1,
                cursor: isDisabled ? "not-allowed" : "pointer",
                "&:hover": {
                  backgroundColor: isDisabled ? "inherit" : "#f5f5f5",
                },
              }}
            >
              <ListItemText
                primaryTypographyProps={{
                  sx: {
                    fontSize: "14px",
                    color: "#3a3a3a",
                    fontWeight: 400,
                  },
                }}
              >
                {item.title}
              </ListItemText>
            </MenuItem>
          );

          if (item.menu) {
            return (
              <MenuItem
                key={item.title}
                onMouseEnter={(e) => {
                  setHoveredMenu(item);
                  setSubmenuAnchorEl(e.currentTarget);
                }}
                onClick={(e) => e.stopPropagation()}
                sx={{
                  height: "36px",
                  padding: "0 16px",
                  "&:hover": {
                    backgroundColor: "#f5f5f5",
                  },
                }}
              >
                <ListItemText
                  primaryTypographyProps={{
                    sx: {
                      fontSize: "14px",
                      color: "#3a3a3a",
                      fontWeight: 400,
                    },
                  }}
                >
                  {item.title}
                </ListItemText>
                <HugeiconsIcon icon={ArrowRight01Icon} size={16} color="#3a3a3a" strokeWidth={0.2} />
              </MenuItem>
            );
          }

          return isDisabled ? (
            <BootstrapTooltip key={item.title} title="This merge tag is not available in preview mode">
              <span>{content}</span>
            </BootstrapTooltip>
          ) : (
            content
          );
        })}
      </Menu>

      <Popper
        open={Boolean(hoveredMenu)}
        anchorEl={submenuAnchorEl}
        placement="right-start"
        disablePortal
        style={{ zIndex: 1302 }}
        modifiers={[
          {
            name: "offset",
            options: {
              offset: [20, 3],
            },
          },
        ]}
        transition
      >
        {({ TransitionProps }) => (
          <Grow {...TransitionProps}>
            <Paper onMouseLeave={handleSubmenuClose} sx={{ minWidth: 180, ...menuPaperStyles }}>
              <ClickAwayListener onClickAway={handleSubmenuClose}>
                <MenuList sx={{ padding: "6px 0" }}>
                  {hoveredMenu?.menu?.map((subItem: any) => {
                    const isDisabled = viewMode === "preview" && subItem.previewDisabled;

                    const content = (
                      <MenuItem
                        key={subItem.value}
                        disabled={isDisabled}
                        onClick={() => {
                          if (!isDisabled) {
                            insertAtCursor(`{{${subItem.value}}}`);
                            handleMainClose();
                          }
                        }}
                        sx={{
                          height: "36px",
                          padding: "0 16px",
                          margin: "2px 0",
                          opacity: isDisabled ? 0.5 : 1,
                          cursor: isDisabled ? "not-allowed" : "pointer",
                          "&:hover": {
                            backgroundColor: isDisabled ? "inherit" : "#f5f5f5",
                          },
                        }}
                      >
                        <ListItemText
                          primaryTypographyProps={{
                            sx: {
                              fontSize: "14px",
                              color: "#3a3a3a",
                              fontWeight: 400,
                            },
                          }}
                        >
                          {subItem.title}
                        </ListItemText>
                      </MenuItem>
                    );

                    return isDisabled ? (
                      <BootstrapTooltip key={subItem.value} title="Not available in Preview mode">
                        <span>{content}</span>
                      </BootstrapTooltip>
                    ) : (
                      content
                    );
                  })}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </>
  );
};

export default MergeTagsDropdown;
